import { LockScreen } from "../../components/auth";

export default function Lock() {
  return (
    <>
      <LockScreen />
    </>
  );
}
